var decoders = exports;

decoders.der = require('./der');
decoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/asn1.js@4.10.1/~/asn1.js/lib/asn1/decoders/index.js
// module id = 287
// module chunks = 0